import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import ConsistentDataImage from './ConnectToTheLeadingDataImage'

const copy = {
  heading: `Connect to the leading cloud data warehouses`,
  description: `Set up and start syncing event and profile data to your preferred cloud data destinations within minutes.`,
}

export const ConnectToTheLeadingData = () => {
  return (
    <StyledSectionBase variant="2Col" copyVariant="narrow">
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ConsistentDataImage />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  justify-content: center;

  ${Section.Wrapper} {
    row-gap: 64px;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-bottom: 160px;
    }
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-bottom: 0;
    }
  }
`

export default ConnectToTheLeadingData
